import { BoxProps, VStack } from "@chakra-ui/react";
import { ReactNode } from "react";
import { Header } from "../components/Header";
import { PageContent } from "../components/PageContent";
import { useScreenSize } from "../providers/ScreenSizeProvider";

interface MainTemplateProps extends BoxProps  {
    children: ReactNode;
    activeNav?: 'HOME' | 'EXPLORE' | 'GENRE' | 'MERCHANDISE' | 'ABOUT_US' | 'HELP_CENTER';
}

export const MainTemplate = ({ children, activeNav = 'HOME', ...rest }: MainTemplateProps) => {
    const { isMobile } = useScreenSize()
    
    return (
        <VStack w={'full'}>
            <Header bg={'#262333'} activeNav={activeNav} />
            <PageContent pt={'110px'} {...rest}>
                {children}
            </PageContent>
        </VStack>
    )
}